import React from 'react';
import styled from '@emotion/styled';
import { MOBILE_END_QUERY } from '../../../styling/mixins/responsive';

import MediaDisplay from '../../Common/MediaDisplay';

const Contents = styled.div`
  position: relative;
  overflow: hidden;

  @media (${MOBILE_END_QUERY}) {
    background-color: ${({ mobileBackgroundColor }) =>
      mobileBackgroundColor ? mobileBackgroundColor : 'transparent'};
  }
`;

const BackgroundMediaDisplay = styled(MediaDisplay)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
`;

export default function VideoBackgroundContainer(props) {
  const {
    className,
    children,
    media,
    imageSize = 'cover',
    layout = 'center',
    mobileBackgroundColor,
  } = props;

  return (
    <Contents
      className={className}
      mobileBackgroundColor={mobileBackgroundColor}
    >
      <BackgroundMediaDisplay
        media={media}
        imageSize={imageSize}
        layout={layout}
      />
      {children}
    </Contents>
  );
}
